import { Modal, Paper } from '@material-ui/core';
import { action, computed, observable } from 'mobx';
import { observer } from 'mobx-react';
import React from 'react';
import Field from '../../../../controls/form/field/field';

import './style.css';

class ItemTemplate extends React.Component {
  render() {
    return <div>{this.props.text}</div>;
  }
}

@observer
class AutoSuggest extends React.Component {
  @observable index = -1;
  @observable anchorEl = null;

  static defaultProps = {
    term: '',
    items: [],
    limit: 20,
    itemTemplate: ItemTemplate,
    filter: (item, term) => {
      return !!item && !!item.text
        ? item.text.toLowerCase().indexOf(term.toLowerCase()) >= 0
        : false;
    }
  };

  render() {
    let { term, label, limit, itemTemplate, disabled, dataTestId } = this.props;

    let empty =
      this.filtered.length === 0 && term.length > 0 ? (
        <div className="autoSuggestInfoItem">No items found</div>
      ) : null;

    let content = this.filtered.map((x, i) => {
      if (i < limit) {
        let selected = i === this.index ? 'autoSuggestItem-selected' : '';

        return (
          <div
            key={i}
            className={`autoSuggestItem ${selected}`}
            onClick={this.onItemSelect.bind(this, x)}
          >
            {React.createElement(itemTemplate, typeof x == 'string' ? { text: x } : x)}
          </div>
        );
      }
    });

    return (
      <React.Fragment>
        <Field
          disabled={disabled}
          value={term}
          label={label}
          liveOnChange={true}
          onChange={this.onChange}
          onKeyDown={this.onKeyDown}
          dataTestId={dataTestId}
        />
        <Modal
          BackdropProps={{
            className: 'autoSuggestBackground'
          }}
          open={Boolean(this.anchorEl)}
          disableEnforceFocus={true}
          disableAutoFocusItem={true}
          disableAutoFocus={true}
          disablePortal={false}
          disableRestoreFocus={true}
          onClose={this.onClose}
          onBackdropClick={this.onClose}
        >
          <Paper style={{ position: 'absolute', ...this.position }}>
            {empty}
            {content}
          </Paper>
        </Modal>
      </React.Fragment>
    );
  }

  @computed
  get position() {
    if (!this.anchorEl) {
      return { top: 0, left: 0 };
    }

    let pos = this.anchorEl.getBoundingClientRect();

    return { top: pos.top + pos.height, left: pos.left };
  }

  @computed
  get filtered() {
    let { term, items, limit, filter } = this.props;
    if (!term) return [];

    return items.filter((x) => filter(x, term)).slice(0, limit);
  }

  @action.bound
  onClose() {
    this.anchorEl = null;
  }

  @action.bound
  onChange(e) {
    let { value } = e.target;

    this.anchorEl = !!value ? e.currentTarget : null;

    this.props.onChange(e.target.value);
  }

  @action.bound
  onItemSelect(item) {
    this.anchorEl = null;
    this.props.onChange(item);
  }

  @action.bound
  onArrow(key) {
    let dir = key === 40 ? 1 : -1;
    let idx = this.index + dir;
    let lim = this.filtered.length - 1;
    this.index = Math.min(Math.max(idx, -1), lim);
  }

  @action.bound
  onKeyDown(e) {
    switch (e.keyCode) {
      case 38:
      case 40:
        e.preventDefault();
        this.onArrow(e.keyCode);
        break;
      case 13:
        this.anchorEl = null;
        this.props.onChange(this.filtered[this.index]);
        break;
      default:
        break;
    }
  }
}

export default AutoSuggest;
